import React from "react";
import { Facebook, Instagram } from "lucide-react";
import { KPL_COMPANY_DETAILS, KPL_LOGO } from "../../constants/siteContent";

export const Footer = () => {
  const socials = [
    { label: "X", href: "https://x.com/TheOfficialKPL", iconType: "x" },
    { label: "Instagram", href: "https://www.instagram.com/kenyanpremierleague", icon: Instagram },
    { label: "Facebook", href: "https://www.facebook.com/TheOfficialKPL", icon: Facebook },
  ];

  return (
    <footer id="contact" data-testid="footer" className="py-10 bg-white border-t border-[#E4E4E7]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid gap-8 md:gap-10 text-left md:grid-cols-[1.45fr_0.55fr_0.85fr] md:items-start">
          <div className="flex flex-col items-start gap-4 md:-ml-4" data-testid="footer-brand-column">
            <div className="flex items-start gap-5" data-testid="footer-brand-row">
              <img src={KPL_LOGO} alt="Kenya Premier League logo" className="w-20 h-20 object-contain" data-testid="footer-logo" />

              <div className="font-bold uppercase leading-[0.88] tracking-[0.22em] text-[#0A0A0A]" data-testid="footer-stacked-brand">
                <p>Kenya</p>
                <p>Premier</p>
                <p>League</p>
              </div>
            </div>

            <div className="pt-1">
              <p className="text-xs text-[#0A0A0A]/70" data-testid="footer-trademark-text">Kenya Premier League © 2022 - 2027. All Rights Reserved</p>
            </div>
          </div>

          <div className="flex flex-col items-start gap-3 md:justify-self-center">
            <div data-testid="footer-socials-block">
              <p className="mb-2 text-xs font-semibold uppercase tracking-[0.2em] text-[#D1111A]">Socials</p>
              <div className="flex items-center gap-3">
                {socials.map((social, index) => (
                  <a
                    key={social.label}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex h-10 w-10 items-center justify-center rounded-full border border-[#0A0A0A]/12 text-[#0A0A0A]/72 hover:border-[#D1111A] hover:text-[#D1111A] transition-colors"
                    data-testid={`footer-social-${index}`}
                    aria-label={social.label}
                  >
                    {social.iconType === "x" ? (
                      <span className="text-sm font-semibold">X</span>
                    ) : (
                      <social.icon size={18} />
                    )}
                  </a>
                ))}
              </div>
            </div>
          </div>

          <div className="flex flex-col items-start gap-2 md:justify-self-end">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#D1111A]" data-testid="footer-contact-label">Contact</p>
            <p className="text-xs text-[#0A0A0A]/55" data-testid="footer-contact-email">info@kenyapremierleague.com</p>
            <p className="pt-1 text-xs text-[#0A0A0A]/60 max-w-sm leading-relaxed" data-testid="footer-company-details">{KPL_COMPANY_DETAILS}</p>
          </div>
        </div>
      </div>
    </footer>
  );
};